import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useSearchParams } from 'react-router-dom';

import { DonorScheduleDonorLink } from '@/components/common/links';
import { ScheduledDonorItem, ScheduledSemenItem } from '@/services/semen-pull';
import {
  useScheduledDonorsQuery,
  useUnfinishedScheduledDonorsQuery,
} from '@/services/semen-pull/hooks';

import './GridCellRenderedComponents.css';

type Props = {
  rowData: ScheduledSemenItem;
};
export const DonorsScheduledScheduledSemenGrid = ({ rowData }: Props) => {
  const [params] = useSearchParams();
  const selectedDate = params.get('date');
  const selectedSiteId = params.get('site');

  const isUnfinished =
    rowData.row === 1 && !!rowData?.name_Type?.includes('()');

  const scheduledDonorsQuery = useScheduledDonorsQuery({
    date: selectedDate,
    siteId: selectedSiteId,
    sireId: rowData.sireId,
    semenId: rowData.semenId,
    accountId: rowData.accountId,
    semenType: rowData.semenTypeName,
    dsSemenLocId: rowData.semenStorageId,
    enabled: !isUnfinished,
  });

  const unfinishedDonorsQuery = useUnfinishedScheduledDonorsQuery({
    date: selectedDate,
    siteId: selectedSiteId,
  });

  const scheduledDonors = isUnfinished
    ? (unfinishedDonorsQuery.data as ScheduledDonorItem[] | undefined)
    : (scheduledDonorsQuery.data as ScheduledDonorItem[] | undefined);

  return (
    <div className="donors-scheduled-grid">
      <DataTable value={scheduledDonors} scrollable>
        <Column
          field="donorName"
          header="Donor"
          body={(rowData: ScheduledDonorItem) => (
            <DonorScheduleDonorLink
              donorScheduleId={rowData.donorScheduleID as string}
              donorName={rowData?.donorName as string}
            />
          )}
        ></Column>
        <Column field="csr" header="CSR"></Column>
      </DataTable>
    </div>
  );
};
